var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('response-button',{attrs:{"loading":_vm.loading,"disabled":_vm.disabled,"label":"common.delete","icon":"delete","color":_vm.color},on:{"click":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }